import { downloadMail } from '@/services/api/endpoints';
import { addBreadcrumb } from '@/services/breadcrumbs/breadcrumbs';
import { reportError } from '@/services/errors/errorReporter';

// Build a filesystem-safe .msg filename from the mail label.
export function mailFilename(name: string): string {
  const base = name.replace(/[\\/:*?"<>|\r\n\t]/g, '_').trim().slice(0, 150);
  return `${base || 'message'}.msg`;
}

// Fetch a filed mail's .msg through the edge proxy (with our bearer token) and
// save it as a blob so Outlook opens it — Leviia rejects presigned URLs. Shared
// by the tree's MailRow and the search results so a mail behaves the same way
// wherever it's clicked. Errors are reported, not thrown: callers just await.
export async function openMail(mailId: string, label: string): Promise<void> {
  addBreadcrumb({ category: 'ui.click', message: 'open-mail', data: { mailId } });
  try {
    const blob = await downloadMail(mailId);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = mailFilename(label);
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  } catch (err) {
    reportError({
      error: err instanceof Error ? err : new Error(String(err)),
      tags: ['mail', 'open'],
    });
  }
}
